module.exports = __webpack_public_path__ + "media/bootstrap-icons/paragraph-31068383.svg";